"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.94,8.22l2.3,2.3,1.82-1.81L9.75,6.4A2.86,2.86,0,0,0,6,2.83a.3.3,0,0,0-.19.23.32.32,0,0,0,.07.28L7,4.6v.83H6.11L4.88,4.3a.29.29,0,0,0-.28-.08.32.32,0,0,0-.23.19A2.85,2.85,0,0,0,5,7.54,2.89,2.89,0,0,0,7.94,8.22Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.61,12.26l-2.2-2.2L11.6,11.88l2.2,2.19A2.86,2.86,0,0,0,14.49,17a2.83,2.83,0,0,0,2,.84,2.92,2.92,0,0,0,1.13-.22.32.32,0,0,0,.19-.23.34.34,0,0,0-.08-.29l-1.22-1.26V15h.84l1.29,1.19a.32.32,0,0,0,.51-.11A2.86,2.86,0,0,0,18.56,13,2.9,2.9,0,0,0,15.61,12.26Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.43,3.65l-1-1a.32.32,0,0,0-.41,0L15.79,4.23a.34.34,0,0,0-.13.23.31.31,0,0,0,.09.26l.6.6L10,11.7,8.84,10.57a.32.32,0,0,0-.45.45l.45.45-4,4a1.28,1.28,0,0,0,1.81,1.81l4-4,.45.45a.34.34,0,0,0,.23.1.32.32,0,0,0,.22-.1.31.31,0,0,0,0-.45l-1.13-1.13L16.8,5.77l.53.53a.33.33,0,0,0,.23.09h0a.31.31,0,0,0,.24-.12l1.64-2.2A.33.33,0,0,0,19.43,3.65Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;